import ShareButtons from './ShareButtons'

export default ShareButtons